<template>
  <div class="type-container">
    <Form :model="formData" ref="formValidate" class="page-form" :label-width="100">
      <div class="form-title">团队长基础管理费：</div>
      <FormItem label="结算方式" prop="isDeduct" :rules="$units.formRule.required('请选择')" class="item">
        <Select v-model="formData.isDeduct" placeholder="请选择" @on-change="isDeductChange">
          <Option value="0">补结（+）</Option>
          <Option value="1" :disabled="commissionIndex > 1">扣款（-）</Option>
        </Select>
      </FormItem>

      <FormItem label="扣款原因" prop="deductType" :rules="$units.formRule.required('请选择')" class="item" v-if="formData.isDeduct == '1'">
        <Select v-model="formData.deductType" placeholder="请选择" clearable transfer @on-change="changeDeductType">
          <Option value="5">补结</Option>
          <Option value="1">退保</Option>
          <Option value="2">部分退保</Option>
          <Option value="3">退现价</Option>
          <Option value="4">其他</Option>
        </Select>
      </FormItem>

      <FormItem
        label="备注"
        prop="deductMsg"
        :rules="$units.formRule.required('请填写原因')"
        v-if="formData.deductType == 4 && formData.isDeduct == 1"
        class="item"
      >
        <Input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="formData.deductMsg" placeholder="请输入" />
      </FormItem>

      <FormItem
        label="基础费率"
        prop="commission"
        key="commission"
        :required="formData.isDeduct == '0' && formData.settlementStatus == '0' && !formData.commission ? false : true"
        :rules="formData.isDeduct == '0' && formData.settlementStatus == '0' && !formData.commission ? [] : [$units.formRule.required(), $units.formRule.positiveNumber('请填写0或正数')]"
        v-if="formData.isDeduct == '0' || (formData.isDeduct == '1' && formData.deductType == 5)"
        class="item"
      >
        <template #label>
          <span :class="{'label-my':formData.isDeduct == '0' && formData.settlementStatus == '0' && !formData.commission}">
            <span class="tips" v-if="formData.isDeduct == '0' && formData.settlementStatus == '0'"></span>
            基础费率
          </span>
        </template>
        <Input v-model="formData.commission" placeholder="请填写0或正数" type="text" @on-blur="calculateCommission" class="input" />
        <span class="unit">%</span>
      </FormItem>

      <FormItem label="保费" class="item" v-if="formData.isDeduct == '0' || !formData.deductType || (formData.isDeduct == '1' && formData.deductType == 5)">
        <span>{{ formData.fee || 0 }}元</span>
      </FormItem>

      <FormItem :label-width="140"  label="退费金额（保费）" prop="fee" class="item" v-else :rules="[$units.formRule.required(), $units.formRule.positiveNumber('请填写0或正数')]" key="fee">
        <Input v-model="formData.fee" placeholder="请填写0或正数" class="input" />
        <span class="unit">元</span>
      </FormItem>

      <FormItem
        label="团队长基础加费"
        :label-width="110"
        class="item"
        v-if="formData.isDeduct == '0' || !formData.deductType || (formData.isDeduct == '1' && formData.deductType == 5)"
      >
        <span>{{ formData.commissionPrice || 0 }}元</span>
      </FormItem>

      <FormItem
        label="扣除团队长基础加费"
        :label-width="140"
        prop="commissionPrice"
        class="item"
        v-else
        :rules="[$units.formRule.required(), $units.formRule.positiveNumber('请填写0或正数')]"
        key="commissionPrice"
      >
        <Input v-model="formData.commissionPrice" placeholder="请填写0或正数" class="input" />
        <span class="unit">元</span>
      </FormItem>

      <FormItem
        :label="sourceType == 1 || commissionType == 2 || levelCode != '10001' ? '下游结算状态' : '上游结算状态'"
        prop="settlementStatus"
        :rules="$units.formRule.required('请选择')"
        class="item"
      >
        <Select v-model="formData.settlementStatus" placeholder="请选择" transfer @on-change="changeSettlementStatus">
          <Option value="1">已结算</Option>
          <Option value="0">未结算</Option>
        </Select>
      </FormItem>

      <FormItem
        label="实际结算费率"
        prop="settlementCommission"
        :rules="$units.formRule.positiveNumber('请填写0或正数')"
        class="item"
        v-if="formData.settlementStatus == 1 && ((formData.isDeduct == '1' && formData.deductType == 5) || formData.isDeduct == '0')"
      >
        <Input v-model="formData.settlementCommission" placeholder="请填写0或正数" class="input" />
        <span class="unit">%</span>
      </FormItem>

      <FormItem label="实际结算金额" prop="settlementCommissionPrice" :rules="$units.formRule.positiveNumber('请填写0或正数')" class="item" v-if="formData.settlementStatus == 1">
        <Input v-model="formData.settlementCommissionPrice" placeholder="请填写0或正数" class="input" />
        <span class="unit">元</span>
      </FormItem>

      <FormItem label="打款日期" class="item" v-if="formData.settlementStatus == 1">
        <template #label>
          <span>
            打款日期
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>费用归属是商户且为补结时代表回款日</p>
                <p>期，为扣款时代表付款日期；费用归属</p>
                <p>是下级机构或业务员且为补结时代表付</p>
                <p>款日期，为扣款时代表收款日期</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <DatePicker type="date" transfer format="yyyy-MM-dd" split-panels v-model="formData.paymentDate" placeholder="请选择"></DatePicker>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  props: ['commissionIndex', 'commissionType', 'levelCode', 'sourceType', 'fee'],
  data() {
    return {
      curFee: '',
      formData: {
        isDeduct: '0',
        commission: null,
        fee: '',
        settlementStatus: '0',
        settlementCommission: null,
        settlementCommissionPrice: null
      }
    };
  },
  watch: {
    commissionIndex(newVal) {
      if (newVal > 1) {
        this.formData.isDeduct = '0';
      }
    },
    fee:{
      handler(){
        this.curFee = this.fee;
        this.setFee(this.curFee);
      },
      immediate: true
    }
  },

  methods: {
    resetFormData() {
      this.formData = {
        isDeduct: '0',
        commission: null,
        fee: '',
        settlementStatus: '0',
        settlementCommission: null,
        settlementCommissionPrice: null
      };
      this.$refs.formValidate.resetFields();
    },
    // 切换结算方式
    isDeductChange(){
      this.$set(this.formData, 'fee', this.curFee);
      this.$set(this.formData, 'commissionPrice', '');
      this.$set(this.formData, 'commission', '');
    },
    // 设置保费
    setFee(data) {
      this.curFee = data+'';
      this.$set(this.formData, 'fee', data+'');
      if (!this.formData.commission) return;
      this.$set(
        this.formData,
        'commissionPrice',
        Number(this.formData.commission)
          .div(100)
          .mul(this.formData.fee)
      );
    },

    // 基础费用-扣款原因切换
    changeDeductType(value) {
      this.$set(this.formData, 'fee', this.curFee);
      if (value != 5) {
        this.$set(this.formData, 'commission', '');
        this.$set(this.formData, 'commissionPrice', '');
      } else {
        this.$set(
          this.formData,
          'commissionPrice',
          Number(this.formData.commission)
            .div(100)
            .mul(this.formData.fee)
        );
      }
    },

    // 基础费用-费用
    calculateCommission($event) {
      if (!$event.target._value || (this.formData.isDeduct == 1 && this.formData.deductType != 5)) return;
      this.$set(
        this.formData,
        'commissionPrice',
        Number($event.target._value)
          .div(100)
          .mul(this.formData.fee)
      );
    },

    // 结算状态
    changeSettlementStatus(value) {
      if (value == 1 && (this.formData.isDeduct == '0' || this.formData.deductType == '5')) {
        this.formData.settlementCommission = this.formData.commission ? this.formData.commission : '';
        this.formData.settlementCommissionPrice = this.formData.commissionPrice ? this.formData.commissionPrice : '';
      }
      if(value == 1 && this.formData.isDeduct == '1' && this.formData.deductType != '5' && this.formData.commissionPrice) {
        this.formData.settlementCommissionPrice = this.formData.commissionPrice ? this.formData.commissionPrice : '';
      }
    },

    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            try {
              resolve({ ...this.formData });
            } catch (error) {
              reject({isError: true});
            }
          } else {
            reject({isError: true});
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.type-container {
  margin: 20px 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .item {
    width: 25%;
    /deep/.ivu-form-item-content{
      display: flex;
    }
    .input {
      width: unset;
      flex: 1;
    }
    .unit {
      float: right;
      margin-left: 6px;
    }
  }
  .label-my {
    .tips::before {
      margin-right: 4px;
      content: '*';
      color: #ed4014;
      font-family: 'SimSun';
    }
  }
}
</style>
